import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeService } from 'src/app/pages/employee/services/employee.service';

@Component({
    selector: 'app-finalize-submit-sign-modal',
    templateUrl: './finalize-submit-sign-modal.component.html',
    styleUrls: ['./finalize-submit-sign-modal.component.css']
})
export class FinalizeSubmitSignModalComponent implements OnInit {
    @ViewChild('signaturePad', { static: false }) signaturePad;
    @Input() proxyData: { [key: string]: any };
    EnableCheckboxSign: boolean;
    signatureNEmpty: boolean;
    submitSignImg: any;
    formData: { [key: string]: any } = {};
    portalSettings: any;
    rawImgData: any;
    showClickMsg: boolean;
    hideClick: boolean;
    redBorder: boolean;
  panelWidth: number;
  signaturePadOptions: Object = {
    'canvasWidth': 430,
    'canvasHeight': 150
  }

    constructor(private portalSettingsService: PortalSettingsService, private ngbActiveModal: NgbActiveModal, private employeeService: EmployeeService) {
        this.portalSettings = portalSettingsService.getPortalSettings();
    }

    ngOnInit(): void {
        this.EnableCheckboxSign = this.portalSettings.EnableCheckboxSign.ConfigValue == "1" ? true : false;
        this.signatureNEmpty = false;
        this.submitSignImg = null;
        this.formData = {};
        this.redBorder = false;
        var width = $("#modal_size").width();
        this.panelWidth = (width > 550 ? 550 : width) + 30;
    }

    clearSignature() {
        if (this.signaturePad != null)
            this.signaturePad.clear();
        this.signatureNEmpty = false;
        this.formData.typeSign = false;
        this.rawImgData = null;
        this.submitSignImg = null;
        this.showClickMsg = false;
        this.hideClick = false;
    }

    submitSignature() {
        if(this.proxyData == null)
            this.signatureTrigger();
        else
            this.ngbActiveModal.close();
    }

    closeSignature() {
        this.ngbActiveModal.dismiss();
    }

    signatureTrigger() {
        if (this.formData.typeSign) {
            this.ngbActiveModal.close(this.rawImgData);
        } else if (this.signaturePad.isEmpty() == false) {
            this.signatureNEmpty = true;
            this.ngbActiveModal.close(this.signaturePad.toDataURL().replace(/^data:image\/(png|jpg);base64,/, ""));
        }
        else {
            this.signatureNEmpty = false;
            this.redBorder = true;
        }
    }

    clickSign(type: string) {
        if (this.signaturePad.isEmpty()) {
            this.formData.typeSign = true;
            this.employeeService.getTypeSign(type).then((response: any) => {
                this.rawImgData = response;
                this.submitSignImg = "data:image/png;base64," + response;
            });
            this.hideClick = true;
            this.showClickMsg = false;
        } else {
            this.showClickMsg = true;
        }
    }

}
